import { IGrantServices } from './grants.types'
import { http } from '@/shared/https'
import { Utilities as utils } from '@/shared/utilities'
import { AppTransformers as transform } from '@/shared/transform'
import { AppConstants as _app } from "@/shared/app.constants";

export class GrantService implements IGrantServices {
    Secretariat = _app.UserType.Secretariat

    /** method to get list of grants */
    listGrants(): any {
        return http.get(`api/Grant/List`).then((resp: any) => {
            if(resp.status >= 200 && resp.status <= 300) {
                return resp.data;
            }
        });
    }

    /** method to get list of grants with filter */
    getGrantsList(params?: any): any {
        return http.get(`api/Grant/GetGrants?${params}`).then((resp: any) => {
            if(resp.status >= 200 && resp.status <= 300) {
                return resp.data;
            }
        });
    }

    /** get dashboard filters */
    getFilters(): any {
        return http.get(`api/Grant/GetFilter`).then((resp: any) => {
            if(resp.status >= 200 && resp.status <= 300) {
                return resp.data;
            }
        });
    }

    /** Get the grant by id */
    getGrant(id: number): any {
        return http.get(`api/Grant/${id}`).then((resp: any) => {
            if(resp.status >= 200 && resp.status <= 300) {
                return resp.data;
            }
        });
    }

    /** Get Grant data */
    getGrantData(id: number): any {
        return http.get(`api/Grant/${id}/data`).then((resp: any) => {
            if(resp.status >= 200 && resp.status <= 300) {
                return resp.data;
            }
        });
    }

    /** Get Grant summary */
    getGrantSummary(id: number): any {
        return http.get(`api/Grant/${id}/summary`).then((resp: any) => {
            if(resp.status >= 200 && resp.status <= 300) {
                return resp.data;
            }
        });
    }

    createGrant(id: number): any {
        return http.post(`api/Grant/Create/${id}`, {}).then((resp) => {
            if(resp.status >= 200 && resp.status <= 300) {
                return resp.data;
            }
        })
    }

    /** method to update the application */
    updateGrant(id: number, grant: any): any {
        return http.put(`api/Grant/${id}`, grant).then((resp: any) => {
            return resp.data
        });
    }

    /** method to update the grant data */
    updateGrantData(id: number, grant: any): any {
        return http.put(`api/Grant/${id}/Data`, grant).then((resp: any) => {
            return resp.data
        });
    }

    updatePPO(id: number, ppoid: number): any {
        return http.put(`api/Grant/${id}/PrimaryProgramOfficer/${ppoid}`, {}).then((resp) => {
            if(resp.status >= 200 && resp.status <= 300) {
                return resp.data;
            }
        })
    }

    ActiveUsersByUserType(): any {
        return http.get(`api/Grant/UserType/${this.Secretariat}/Active`)
        .then((resp: any) => {
            return resp.data;
        });
    }

    // format the grant info
    formatGrantInfo(datum): any {
        if(datum) {
            if(datum.ActualStartDate) {
                datum.StartDate = datum.ActualStartDate;
            }

            if(datum.ExpectedEndDate) {
                datum.EndDate = datum.ExpectedEndDate;
            }
        }
        return datum;
    }
    
    changeOwnership(id: number, userId: number, type: string): any {
        return http.post(`api/OwnershipTransfer/${id}/User/${userId}/${type}`, {}).then((resp) => {
            if(resp.status >= 200 && resp.status <= 300) {
                return resp.data;
            }
        })
    }
}
